import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";
import Shell from "@/pages/admin/AdminLayout";
import POS from "@/pages/POS";
import CustomerDisplay from "@/pages/CustomerDisplay";
import Dashboard from "@/pages/admin/Dashboard";
import Products from "@/pages/admin/Products";
import Safe from "@/pages/admin/Safe";
import CashDrawer from "@/pages/admin/CashDrawer";
import DailySales from "@/pages/admin/DailySales";
import SalesHistory from "@/pages/admin/SalesHistory";
import InventoryReports from "@/pages/admin/InventoryReports";
import History from "@/pages/admin/History";
import PrizeCodes from "@/pages/admin/PrizeCodes";
import WebsiteSync from "@/pages/admin/WebsiteSync";
import Customers from "@/pages/admin/Customers";
import Settings from "@/pages/admin/Settings";

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to="/pos" replace />;
  return children;
}

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/pos" replace />;
  return <Login />;
}

const MGR = ["owner", "manager"];

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/display/:token" element={<CustomerDisplay />} />
            <Route path="/" element={<ProtectedRoute><Shell /></ProtectedRoute>}>
              <Route index element={<Navigate to="/pos" replace />} />
              <Route path="pos" element={<POS />} />
              <Route path="cash-drawer" element={<CashDrawer />} />
              <Route path="customers" element={<Customers />} />
              <Route path="daily-sales" element={<DailySales />} />
              <Route path="sales" element={<SalesHistory />} />
              <Route path="dashboard" element={<ProtectedRoute roles={MGR}><Dashboard /></ProtectedRoute>} />
              <Route path="products" element={<ProtectedRoute roles={MGR}><Products /></ProtectedRoute>} />
              <Route path="safe" element={<ProtectedRoute roles={MGR}><Safe /></ProtectedRoute>} />
              <Route path="inventory-reports" element={<ProtectedRoute roles={MGR}><InventoryReports /></ProtectedRoute>} />
              <Route path="history" element={<ProtectedRoute roles={MGR}><History /></ProtectedRoute>} />
              <Route path="prize-codes" element={<ProtectedRoute roles={MGR}><PrizeCodes /></ProtectedRoute>} />
              <Route path="website-sync" element={<ProtectedRoute roles={MGR}><WebsiteSync /></ProtectedRoute>} />
              <Route path="settings" element={<ProtectedRoute roles={MGR}><Settings /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
